/**
 * Created by Ganesh.Sharma on 15-10-2016.
 */
 define(['edge/platform/base/BaseCtrl','underscore'], (BaseCtrl, _)=> {
    const fn =($scope, $stateParams, $state, submissionViewModel , ModalService, PrefillService , $q, StateUtils, InMemorySession)=> {
    const ctrl = Object.create(BaseCtrl);
const flowModel = StateUtils.activeDataForState(true).flowModel;
const submissionVM = submissionViewModel();


ctrl.init = ()=> {

    const today = new Date();
    $scope.prevCarrierInfo = submissionVM.draftData.lobs.personalAuto.prevCarrierInfo;
    $scope.prevCarrierInfo.value = $scope.prevCarrierInfo.value || {};
    $scope.today = new Date();
    $scope.today.setHours(0, 0, 0, 0);

    $scope.retrievePrevCarrierInfo = submissionVM.draftData.retrievePrevCarrierInfo;
    $scope.retrievePrevCarrierInfo.value = $scope.retrievePrevCarrierInfo.value || {};
    
    var otherOption = _.find($scope.prevCarrierInfo.insuranceCarriers.aspects.availableValues, function(limit){ return limit.code == "Other"; });
    $scope.insuranceCarriers = _.filter($scope.prevCarrierInfo.insuranceCarriers.aspects.availableValues, function(limit){ return limit.code != "Other"; });
    $scope.insuranceCarriers.push(otherOption);
    /* ENHC0011961_EODB QnB Defaults -added code for defaulting insurance information -- Arpita Sengupta */
    let insuranceCarriersArr = $scope.prevCarrierInfo.insuranceCarriers.aspects.availableValues;
    let priorBILimitArr = $scope.prevCarrierInfo.priorBILimits.aspects.availableValues;
    //defaulting insuranceCarriers
    for(let insC = 0;  insC<=insuranceCarriersArr.length; insC++){
        if(insuranceCarriersArr[insC] && insuranceCarriersArr[insC].code && insuranceCarriersArr[insC].code == "Other"){
            $scope.prevCarrierInfo.insuranceCarriers = insuranceCarriersArr[insC].code;
        }
    }
    //defaulting priorBILimits
    for(let priorBIL = 0;  priorBIL<=priorBILimitArr.length; priorBIL++){
        if(priorBILimitArr[priorBIL] && priorBILimitArr[priorBIL].code && priorBILimitArr[priorBIL].code == "100_300"){
            $scope.prevCarrierInfo.priorBILimits = priorBILimitArr[priorBIL].code;
        }
    }
    /*ended*/
    $scope.policyStatusValue = {
        "I have Insurance" : "I have Insurance",
        "I don't have Insurance" : "I don't have Insurance",
        "My Insurance cancelled or expired" : "My Insurance cancelled or expired"
    };
    /* ENHC0011961_EODB QnB Defaults -- Arpita Sengupta */
    if($scope.policyStatusValue["I have Insurance"] !== undefined){
        $scope.prevCarrierInfo.portalStatus = $scope.policyStatusValue["I have Insurance"];
    }
    /*ended*/
    $scope.lapsePeriod = today.setHours(720,0,0,0);

    const quoteID = submissionVM.quoteID.value;
    var prefillReq ={
        "submissionNumber": quoteID,
        "isFromPriorPolicy": true
    };

    if($scope.retrievePrevCarrierInfo.value.policyStatus != null)
    {
        if($scope.retrievePrevCarrierInfo.value.policyStatus == 'Active')
        {
            $scope.prevCarrierInfo.portalStatus.value = "I have Insurance";
        }
        else if($scope.retrievePrevCarrierInfo.value.policyStatus == 'NoPrior'){
            $scope.prevCarrierInfo.portalStatus.value = "I don't have Insurance" ;
        }
        else{
            $scope.prevCarrierInfo.portalStatus.value = "My Insurance cancelled or expired" ;
        }
        $scope.prevCarrierInfo.insuranceCarriers.value = $scope.retrievePrevCarrierInfo.value.insuranceCarriers;
        $scope.prevCarrierInfo.expirationDate.value = $scope.retrievePrevCarrierInfo.value.expirationDate;
        $scope.prevCarrierInfo.priorBILimits = $scope.retrievePrevCarrierInfo.value.priorBILimits;
    }
    //INC2762580 Remove LN Service Call
    //Un-commenting below else part for Data Prefill *Princy
    //else {
        var responsePromise = PrefillService.getDriverVehiclePrefillData(prefillReq);
        ModalService.showProgressDialog('quoteandbind.controllers.Please wait', responsePromise);
        responsePromise.then(function (response) {
            // Setting the prefill data in Factory for reuse - INC0019969
            if(typeof response === 'object' && (response != null)) {
                // decrypting prefill data start devendra
                if (typeof response.drivers !== 'undefined' && response.drivers.length > 0) {
                    for(idx=0;idx<response.drivers.length;idx++){
                        if(response.drivers[idx].eNCDateOfBirth != null && typeof response.drivers[idx].eNCDateOfBirth !== 'undefined'){
                            let temDob = InMemorySession.decryptData(response.drivers[idx].eNCDateOfBirth).split(' ')[0]+"T05:00:00Z";
                            let dob = new Date(temDob)
                            response.drivers[idx].dateOfBirth = dob;
                        }
                        if(response.drivers[idx].eNCGender != null && typeof response.drivers[idx].eNCGender !== 'undefined'){
                            // prefill --Arpita
                            response.drivers[idx].gender = InMemorySession.decryptData(response.drivers[idx].eNCGender) ? response.drivers[idx].eNCGender : InMemorySession.decryptData(response.drivers[idx].eNCGender);
                        }
                        if(response.drivers[idx].eNCLicenseNumber != null && typeof response.drivers[idx].eNCLicenseNumber !== 'undefined'){
                            response.drivers[idx].licenseNumber = InMemorySession.decryptData(response.drivers[idx].eNCLicenseNumber) ? response.drivers[idx].eNCLicenseNumber : InMemorySession.decryptData(response.drivers[idx].eNCLicenseNumber);
                        }
                        if(response.drivers[idx].eNCLicenseState != null && typeof response.drivers[idx].eNCLicenseState !== 'undefined'){
                            response.drivers[idx].licenseState = InMemorySession.decryptData(response.drivers[idx].eNCLicenseState) ? response.drivers[idx].eNCLicenseState : InMemorySession.decryptData(response.drivers[idx].eNCLicenseState);
                        }
                    }
                }
                if(typeof response.vehicles !== 'undefined' && response.vehicles.length > 0){
                    for(idxv=0;idxv<response.vehicles.length;idxv++){
                        if(response.vehicles[idxv].encryptedVIN != null && typeof response.vehicles[idxv].encryptedVIN !== 'undefined'){
                            response.vehicles[idxv].vin = InMemorySession.decryptData(response.vehicles[idxv].encryptedVIN) ? response.vehicles[idxv].encryptedVIN : InMemorySession.decryptData(response.vehicles[idxv].encryptedVIN);
                        }
                    }
                }
                // decrypting prefill data end devendra
                InMemorySession.setPrefillData(response)
            }
            if (typeof response === 'object' &&
                (typeof response.priorPolicies !== 'undefined')) {
                if(response.priorPolicies[0].policyStatus == 'Active' || response.priorPolicies[0].policyStatus == 'IN-EFFECT'
                    || response.priorPolicies[0].policyStatus == 'in-effect' || response.priorPolicies[0].policyStatus == 'active'
                )
                {
                    $scope.prevCarrierInfo.portalStatus.value = "I have Insurance";
                }
                else if(response.priorPolicies[0].policyStatus == 'NoPrior'){
                    $scope.prevCarrierInfo.portalStatus.value = "I don't have Insurance" ;
                }
                else{
                    $scope.prevCarrierInfo.portalStatus.value = "My Insurance cancelled or expired" ;
                }
                $scope.prevCarrierInfo.insuranceCarriers.value = response.priorPolicies[0].carrier;
                $scope.prevCarrierInfo.expirationDate.value = response.priorPolicies[0].expirationDate;
                $scope.prevCarrierInfo.effectiveDate.value = response.priorPolicies[0].effectiveDate;
                $scope.prevCarrierInfo.policyNumber.value = response.priorPolicies[0].policyNumber;
                $scope.prevCarrierInfo.priorBILimits = response.priorPolicies[0].priorBILimit;
            }
        });
    //}



};


ctrl.next = function (form) {

// PC Mapping corresponding to the policy status type list, based on validations

    if ($scope.prevCarrierInfo.portalStatus.value == "My Insurance cancelled or expired" && new Date($scope.prevCarrierInfo.expirationDate.value).getDate()< $scope.lapsePeriod ){
        $scope.prevCarrierInfo.policyStatus = "Lapse30Less";
    }
    if($scope.prevCarrierInfo.portalStatus.value == "My Insurance cancelled or expired" /*&& $scope.prevCarrierInfo.expirationDate.value !== null*/
        && new Date($scope.prevCarrierInfo.expirationDate.value).getDate() > $scope.lapsePeriod ){
        $scope.prevCarrierInfo.policyStatus  = "Lapse30DaysMore";
    }
    if($scope.prevCarrierInfo.portalStatus.value == "I have Insurance"){
        $scope.prevCarrierInfo.policyStatus = "Active";
        $scope.prevCarrierInfo.expirationDate = undefined;
    }

    if($scope.prevCarrierInfo.portalStatus.value == "I don't have Insurance"){
        $scope.prevCarrierInfo.policyStatus  = "NoPrior";
        $scope.prevCarrierInfo.expirationDate = undefined;
        $scope.prevCarrierInfo.insuranceCarriers = undefined;
        $scope.prevCarrierInfo.priorBILimits = undefined;
    }

    /*if($scope.prevCarrierInfo.priorBILimits.value == "Other"){
        $scope.prevCarrierInfo.priorBILimits = "MinimumLimits";
    }*/



    InMemorySession.setBiLimits($scope.prevCarrierInfo.priorBILimits.value);
    form.submitted = true;
    flowModel.next(submissionVM);
};

ctrl.cancel = function () {
    flowModel.cancel(submissionVM);
};





return ctrl.create($scope);
};
fn.$inject = ['$scope', '$stateParams', '$state', 'submissionViewModel','ModalService', 'PrefillService', '$q', 'StateUtils', 'InMemorySession'];

return fn;
});



/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/quoteandbind/pa/controllers/PrevCarrierInfoCtrl.js
 **/